module.exports = __webpack_public_path__ + "posture/static/img/leg_o_left.8f265c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/leg_o_left.png
// module id = 5VGa
// module chunks = 1